const componentHeight = {
  small: 35,
  standard: 45,
  large: 65,
}

export default componentHeight
